import React from "react";
import { Link } from "react-router-dom";
import { Badge, Input, Label, UncontrolledTooltip } from "reactstrap";
import moment from "moment-timezone";

export const selectRow = (props) => ({
  mode: "checkbox",
  clickToSelect: true,
  selectionHeaderRenderer: ({ indeterminate, mode, ...rest }) => (
    <div className="custom-control custom-checkbox">
      <Input
        type="checkbox"
        className="custom-control-input"
        ref={(input) => {
          if (input) input.indeterminate = indeterminate;
        }}
        {...rest}
      />
      <Label className="custom-control-label">&nbsp;</Label>
    </div>
  ),
  selectionRenderer: ({ mode, rowKey, ...rest }) => (
    <div className="custom-control custom-checkbox" key={rowKey}>
      <input type="checkbox" className="custom-control-input" {...rest} />
      <Label className="custom-control-label">&nbsp;</Label>
    </div>
  ),
  ...props,
});

const CustomersColumns = (toggleConfirmModal,onEditHandler, t) => [
  {
    dataField: "name",
    text: t("name"),
    sort: true,
    formatter: (_, row) => row.name,
  },
  {
    dataField: "mobileNumber",
    text: t("mobile"),
    sort: true,
    formatter: (_, row) => (row.mobileNumber ? row?.countryCode +" "+ row.mobileNumber : <><div className="d-flex justify-content-center">-</div></>),

  },
  {
    dataField: "email",
    text: t("email"),
    sort: true,
  },
  {
    text: t("created_at"),
    dataField: "date_created_utc",
    sort: true,
    formatter: (_, row) =>
      moment(row.createdAt).utcOffset(330).format("DD MMM YYYY LT"),
  },
  {
    dataField: "status",
    text: t("status"),
    sort: true,
    formatter: (_, row) => {
      return (
      <div className={`${row.status === "active" ? "status_active" :"status_inactive"}`}>
        <span className="text-capitalize">{row.status}</span>
      </div>
      )
    }
  },
  {
    isDummyField: true,
    text: t("action"),
    dataField: "action",
    formatter: (_, row) => (
      <>
      <Link href="javascipt.void(0)" className="mx-2" onClick={(e)=>{
           e.preventDefault();
           onEditHandler(row);
      }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_20_1134)">
            <path d="M17.4287 2.47381L14.9549 0L12.0688 2.88613L14.1303 8.24602L17.4287 2.47381Z" fill="#FF3E3A"/>
            <path d="M17.4286 2.47363L12.8934 7.00894L17.0164 7.83353L19.9025 4.94744L17.4286 2.47363Z" fill="#CC3245"/>
            <path d="M1.33004 15.8018L0 19.9026L4.3647 17.1872L1.33004 15.8018Z" fill="#373E9F"/>
            <path d="M9.15527e-05 19.9023L4.10097 18.5723L3.54012 16.3623L9.15527e-05 19.9023Z" fill="#340D66"/>
            <path d="M7.32247 14.2293L2.37489 12.5801L1.33005 15.8016L2.71548 17.187L7.32247 14.2293Z" fill="#FFE7B5"/>
            <path d="M2.71545 17.1871L4.10093 18.5726L7.3224 17.5278L6.49781 13.4048L2.71545 17.1871Z" fill="#FFD06A"/>
            <path d="M4.84863 15.0538L7.3224 17.5276L17.0164 7.83363L14.5426 5.35986L8.08327 8.52076L4.84863 15.0538Z" fill="#FF9A27"/>
            <path d="M2.37393 12.5797L12.0664 2.88721L14.5398 5.36062L4.84734 15.0531L2.37393 12.5797Z" fill="#FFB820"/>
            </g>
            <defs>
            <clipPath id="clip0_20_1134">
            <rect width="19.9024" height="19.9024" fill="white"/>
            </clipPath>
            </defs>
       </svg>
       </Link>
        <Link to={`/parking-owner/${row._id}`} className="mx-2 text-secondary">
        <svg
           id={`view-${row._id}-tooltip`}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <g clip-path="url(#clip0_102_1928)">
              <path
                d="M23.6766 11.5625C21.321 6.32616 16.9811 2.81396 12.0168 2.81396V20.6007C16.9811 20.6007 21.321 17.0885 23.6766 11.8521C23.6875 11.8277 23.6955 11.8021 23.7006 11.7758V11.6388C23.6956 11.6126 23.6875 11.587 23.6766 11.5625Z"
                fill="#FFAD84"
              />
              <path
                d="M22.0727 11.7073C20.0654 6.39099 16.3139 2.81396 12.0169 2.81396C7.00696 2.81396 2.63307 6.39099 0.292725 11.7073C2.63307 17.0236 7.00696 20.6007 12.0169 20.6007C16.3139 20.6007 20.0654 17.0236 22.0727 11.7073Z"
                fill="#FFD4A1"
              />
              <path
                d="M23.7007 11.6388C21.3507 7.62956 16.9984 4.93701 12.0168 4.93701V18.4776C16.9984 18.4776 21.3507 15.785 23.7007 11.7758C23.7096 11.7306 23.7096 11.684 23.7007 11.6388Z"
                fill="#FE8566"
              />
              <path
                d="M22.0727 11.7073C20.0654 7.66013 16.3139 4.93701 12.0169 4.93701C7.56449 4.93701 3.6146 7.08789 1.14786 10.4074C0.644874 10.6245 0.292725 11.1247 0.292725 11.7073C0.292725 12.2899 0.644874 12.7902 1.14786 13.0072C3.6146 16.3267 7.56449 18.4776 12.0169 18.4776C16.3139 18.4776 20.0654 15.7545 22.0727 11.7073Z"
                fill="#FFAD84"
              />
              <path
                d="M18.161 8.02379C16.307 6.93044 14.1824 6.35254 12.0168 6.35254V17.0623C14.1824 17.0623 16.3071 16.4844 18.161 15.3911C19.7224 14.4703 21.0616 13.2068 22.0726 11.7074C21.0616 10.2081 19.7224 8.94459 18.161 8.02379Z"
                fill="#FFFBBE"
              />
              <path
                d="M20.6573 11.7074C19.7886 10.2081 18.6379 8.94455 17.2962 8.02379C15.7032 6.93044 13.8776 6.35254 12.0169 6.35254C9.8513 6.35254 7.72661 6.93044 5.87268 8.02379C4.31127 8.94459 2.97212 10.2081 1.96106 11.7074C2.97212 13.2068 4.31127 14.4703 5.87268 15.3911C7.72666 16.4844 9.8513 17.0623 12.0169 17.0623C13.8776 17.0623 15.7032 16.4844 17.2962 15.3911C18.6379 14.4703 19.7886 13.2068 20.6573 11.7074Z"
                fill="white"
              />
              <path
                d="M12.0168 6.35254V17.0623C14.9743 17.0623 17.3717 14.6649 17.3717 11.7074C17.3717 8.75002 14.9743 6.35254 12.0168 6.35254Z"
                fill="#01B1BC"
              />
              <path
                d="M15.9564 11.7074C15.9564 8.75002 14.1926 6.35254 12.0169 6.35254C9.05947 6.35254 6.66199 8.75002 6.66199 11.7074C6.66199 14.6649 9.05947 17.0623 12.0169 17.0623C14.1926 17.0623 15.9564 14.6649 15.9564 11.7074Z"
                fill="#3AC7CF"
              />
              <path
                d="M12.0168 9.18311V14.2313C13.4109 14.2313 14.541 13.1012 14.541 11.7072C14.541 10.3132 13.4109 9.18311 12.0168 9.18311Z"
                fill="#20335A"
              />
              <path
                d="M13.1256 11.7072C13.1256 10.3132 12.6293 9.18311 12.0169 9.18311C10.6229 9.18311 9.4928 10.3132 9.4928 11.7072C9.4928 13.1012 10.6229 14.2313 12.0169 14.2313C12.6293 14.2313 13.1256 13.1013 13.1256 11.7072Z"
                fill="#2B4478"
              />
            </g>
            <defs>
              <clipPath id="clip0_102_1928">
                <rect
                  width="23.4146"
                  height="23.4146"
                  fill="white"
                  transform="translate(0.292725)"
                />
              </clipPath>
            </defs>
          </svg>
          <UncontrolledTooltip
            placement="top"
            target={`view-${row._id}-tooltip`}
          >
            {t("view")} {t("details")}
          </UncontrolledTooltip>
        </Link>
        <Link  to="#"
            onClick={(e) => {
              e.preventDefault();
              toggleConfirmModal(row._id);
            }} 
           className="mx-2 text-secondary">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <g clip-path="url(#clip0_20_1145)">
            <path d="M3.24396 4.09766V18.1464C3.24396 18.5604 3.40842 18.9575 3.70116 19.2502C3.9939 19.543 4.39094 19.7074 4.80493 19.7074H17.2927C17.7067 19.7074 18.1038 19.543 18.3965 19.2502C18.6893 18.9575 18.8537 18.5604 18.8537 18.1464V4.09766H3.24396ZM7.92688 16.1952C7.92688 16.2987 7.88577 16.398 7.81258 16.4712C7.7394 16.5443 7.64014 16.5855 7.53664 16.5855H6.75615C6.65265 16.5855 6.55339 16.5443 6.48021 16.4712C6.40702 16.398 6.36591 16.2987 6.36591 16.1952V7.60985C6.36591 7.50635 6.40702 7.40709 6.48021 7.33391C6.55339 7.26072 6.65265 7.21961 6.75615 7.21961H7.53664C7.64014 7.21961 7.7394 7.26072 7.81258 7.33391C7.88577 7.40709 7.92688 7.50635 7.92688 7.60985V16.1952ZM11.8293 16.1952C11.8293 16.2987 11.7882 16.398 11.715 16.4712C11.6418 16.5443 11.5426 16.5855 11.4391 16.5855H10.6586C10.5551 16.5855 10.4558 16.5443 10.3826 16.4712C10.3095 16.398 10.2683 16.2987 10.2683 16.1952V7.60985C10.2683 7.50635 10.3095 7.40709 10.3826 7.33391C10.4558 7.26072 10.5551 7.21961 10.6586 7.21961H11.4391C11.5426 7.21961 11.6418 7.26072 11.715 7.33391C11.7882 7.40709 11.8293 7.50635 11.8293 7.60985V16.1952ZM15.7318 16.1952C15.7318 16.2987 15.6906 16.398 15.6175 16.4712C15.5443 16.5443 15.445 16.5855 15.3415 16.5855H14.561C14.4575 16.5855 14.3583 16.5443 14.2851 16.4712C14.2119 16.398 14.1708 16.2987 14.1708 16.1952V7.60985C14.1708 7.50635 14.2119 7.40709 14.2851 7.33391C14.3583 7.26072 14.4575 7.21961 14.561 7.21961H15.3415C15.445 7.21961 15.5443 7.26072 15.6175 7.33391C15.6906 7.40709 15.7318 7.50635 15.7318 7.60985V16.1952Z" fill="#F16573"/>
            <path d="M15.3727 6.82959H14.5298C14.4177 6.82959 14.3101 6.87386 14.2304 6.95279C14.1507 7.03172 14.1055 7.13892 14.1044 7.25105V16.5545C14.1055 16.6666 14.1507 16.7738 14.2304 16.8527C14.3101 16.9317 14.4177 16.9759 14.5298 16.9759H15.3727C15.4849 16.9759 15.5925 16.9317 15.6721 16.8527C15.7518 16.7738 15.7971 16.6666 15.7981 16.5545V7.25105C15.7971 7.13892 15.7518 7.03172 15.6721 6.95279C15.5925 6.87386 15.4849 6.82959 15.3727 6.82959ZM15.7318 16.1954C15.7318 16.2989 15.6906 16.3982 15.6175 16.4714C15.5443 16.5446 15.445 16.5857 15.3415 16.5857H14.561C14.4575 16.5857 14.3583 16.5446 14.2851 16.4714C14.2119 16.3982 14.1708 16.2989 14.1708 16.1954V7.61008C14.1708 7.50658 14.2119 7.40732 14.2851 7.33413C14.3583 7.26095 14.4575 7.21983 14.561 7.21983H15.3415C15.445 7.21983 15.5443 7.26095 15.6175 7.33413C15.6906 7.40732 15.7318 7.50658 15.7318 7.61008V16.1954ZM11.4391 6.82959H10.5961C10.484 6.82959 10.3764 6.87386 10.2967 6.95279C10.2171 7.03172 10.1718 7.13892 10.1708 7.25105V16.5545C10.1718 16.6666 10.2171 16.7738 10.2967 16.8527C10.3764 16.9317 10.484 16.9759 10.5961 16.9759H11.4391C11.5512 16.9759 11.6588 16.9317 11.7385 16.8527C11.8181 16.7738 11.8634 16.6666 11.8644 16.5545V7.25105C11.8634 7.13892 11.8181 7.03172 11.7385 6.95279C11.6588 6.87386 11.5512 6.82959 11.4391 6.82959ZM11.7981 16.1954C11.7981 16.2989 11.757 16.3982 11.6838 16.4714C11.6106 16.5446 11.5114 16.5857 11.4079 16.5857H10.6274C10.5239 16.5857 10.4246 16.5446 10.3514 16.4714C10.2782 16.3982 10.2371 16.2989 10.2371 16.1954V7.61008C10.2371 7.50658 10.2782 7.40732 10.3514 7.33413C10.4246 7.26095 10.5239 7.21983 10.6274 7.21983H11.4079C11.5114 7.21983 11.6106 7.26095 11.6838 7.33413C11.757 7.40732 11.7981 7.50658 11.7981 7.61008V16.1954ZM7.50541 6.82959H6.66249C6.55035 6.82959 6.44274 6.87386 6.36308 6.95279C6.28342 7.03172 6.23815 7.13892 6.23712 7.25105V16.5545C6.23815 16.6666 6.28342 16.7738 6.36308 16.8527C6.44274 16.9317 6.55035 16.9759 6.66249 16.9759H7.50541C7.61756 16.9759 7.72516 16.9317 7.80482 16.8527C7.88448 16.7738 7.92975 16.6666 7.93078 16.5545V7.25105C7.92975 7.13892 7.88448 7.03172 7.80482 6.95279C7.72516 6.87386 7.61756 6.82959 7.50541 6.82959ZM7.86444 16.1954C7.86444 16.2989 7.82332 16.3982 7.75014 16.4714C7.67695 16.5446 7.57769 16.5857 7.47419 16.5857H6.69371C6.59021 16.5857 6.49095 16.5446 6.41776 16.4714C6.34458 16.3982 6.30346 16.2989 6.30346 16.1954V7.61008C6.30346 7.50658 6.34458 7.40732 6.41776 7.33413C6.49095 7.26095 6.59021 7.21983 6.69371 7.21983H7.47419C7.57769 7.21983 7.67695 7.26095 7.75014 7.33413C7.82332 7.40732 7.86444 7.50658 7.86444 7.61008V16.1954Z" fill="#DB5669"/>
            <path d="M11.0488 4.09766L16.2082 4.67092C16.3991 4.69215 16.5755 4.78303 16.7036 4.92616C16.8317 5.0693 16.9025 5.25465 16.9025 5.44673V19.7074H17.2927C17.7067 19.7074 18.1038 19.543 18.3965 19.2502C18.6892 18.9575 18.8537 18.5604 18.8537 18.1464V4.09766H11.0488Z" fill="#DB5669"/>
            <path d="M10.6586 4.09766L4.80493 4.74819V19.7074C4.39094 19.7074 3.9939 19.543 3.70116 19.2502C3.40842 18.9575 3.24396 18.5604 3.24396 18.1464V4.09766H10.6586Z" fill="#F97A8D"/>
            <path d="M8.70734 0.195312H13.3903C13.8043 0.195313 14.2013 0.359772 14.494 0.652512C14.7868 0.945252 14.9512 1.34229 14.9512 1.75629V2.53678H7.14636V1.75629C7.14636 1.34229 7.31082 0.945252 7.60356 0.652512C7.8963 0.359772 8.29334 0.195313 8.70734 0.195312Z" fill="#374F68"/>
            <path d="M1.29271 2.53662H20.4147C20.5182 2.53662 20.6174 2.57774 20.6906 2.65092C20.7638 2.72411 20.8049 2.82337 20.8049 2.92687V3.70735C20.8049 3.81085 20.7638 3.91011 20.6906 3.9833C20.6174 4.05648 20.5182 4.0976 20.4147 4.0976H1.29271C1.18921 4.0976 1.08995 4.05648 1.01677 3.9833C0.943581 3.91011 0.902466 3.81085 0.902466 3.70735V2.92687C0.902466 2.82337 0.943581 2.72411 1.01677 2.65092C1.08995 2.57774 1.18921 2.53662 1.29271 2.53662Z" fill="#30455C"/>
            <path d="M20.8049 2.92687H1.68295C1.57945 2.92687 1.48019 2.96798 1.40701 3.04116C1.33382 3.11435 1.29271 3.21361 1.29271 3.31711V4.0976C1.18921 4.0976 1.08995 4.05648 1.01677 3.9833C0.943581 3.91011 0.902466 3.81085 0.902466 3.70735V2.92687C0.902466 2.82337 0.943581 2.72411 1.01677 2.65092C1.08995 2.57774 1.18921 2.53662 1.29271 2.53662H20.4147C20.5182 2.53662 20.6174 2.57774 20.6906 2.65092C20.7638 2.72411 20.8049 2.82337 20.8049 2.92687Z" fill="#374F68"/>
            <path d="M9.48783 0.585556H14.1708C14.2652 0.584776 14.3592 0.593752 14.4517 0.612874C14.163 0.345167 13.784 0.196077 13.3903 0.195312L8.70734 0.195313C8.29334 0.195313 7.8963 0.359772 7.60356 0.652512C7.31082 0.945252 7.14636 1.34229 7.14636 1.75629V2.53678H11.8293L9.00705 2.25463C8.84882 2.23927 8.69906 2.17597 8.5778 2.07318C8.45653 1.9704 8.36955 1.83303 8.32847 1.67947C8.28739 1.5259 8.29419 1.36345 8.34795 1.21385C8.40171 1.06425 8.49986 0.934635 8.62929 0.842337C8.88405 0.674316 9.18264 0.585011 9.48783 0.585556Z" fill="#46617A"/>
            </g>
            <defs>
            <clipPath id="clip0_20_1145">
            <rect width="19.9024" height="19.9024" fill="white" transform="translate(0.902466)"/>
            </clipPath>
            </defs>
        </svg>
        </Link>
      </>
    ),
  },
];

export default CustomersColumns;
